// removed by extract-text-webpack-plugin
module.exports = {"container":"WarningMessage__container___2aGL5","warning-container":"WarningMessage__warning-container___3E5M9","warning-text":"WarningMessage__warning-text___36QYG"};